// @ts-check

import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** @param {import('@liquidweb-dev/undercurrent/Box').BoxProps} props */
const FancyHighlight = ({ sx, ...rest }) => {
	return (
		<Box
			component="span"
			sx={combineSx(
				({ palette, borderRadius }) => ({
					paddingY: 50,
					paddingX: 100,
					backgroundColor: palette.uc.highlight.bg.weak,
					border: 'solid 1px',
					borderColor: palette.uc.highlight.border.weak,
					borderRadius: borderRadius.roundedXS,
				}),
				sx,
			)}
			{...rest}
		/>
	);
};

export default FancyHighlight;
